import {useState,useEffect} from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import UseLangLstQuery from "Apis/LangTxtInqApi";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
// import required modules
import { Autoplay, Pagination} from 'swiper/modules';
import { Link } from "react-router-dom";

const GameMainEventBnrUi = ({gameSvcCd,gameMainPageInfo}:any) => {
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const [gameMainPageInfoState,setGameMainPageInfoState] = useState<any>();
    const [isMobile, setIsMobile] = useState(window.innerHeight > window.innerWidth);
    
    useEffect(()=>{
         setGameMainPageInfoState(gameMainPageInfo);
     },[gameMainPageInfo]);
    
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerHeight > window.innerWidth);
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    
    // URL의 확장자로 미디어 타입 확인
    const getMediaType = (url: string) => {
        if (!url) return 'image';
        const extension = url.split('.').pop()?.toLowerCase();
        return extension === 'mp4' || extension === 'webm' || extension === 'ogg' ? 'video' : 'image';
    };
    
    // 로딩 상태 처리
    if (isLoading || !gameMainPageInfoState) {
        return (
            <div className="container eventSlideWrap">
                <div className="loading-banner">
                    
                </div>
            </div>
        );
    }
    return(
        <div className="container eventSlideWrap">
            <Swiper
                spaceBetween={0}
                centeredSlides={true}
                autoplay={{
                delay: 10000,
                disableOnInteraction: false,
                }}
                pagination={{
                clickable: true,
                }}
                modules={[Autoplay, Pagination]}
                className="eventSlide"
            >
                
                <SwiperSlide>
                    <video
                        src={isMobile 
                            ? 'https://bb-cdn.gameking.com/web/mainpage/mainBgMo.mp4' 
                            : 'https://bb-cdn.gameking.com/web/mainpage/mainBg.mp4'
                        }
                        autoPlay
                        loop
                        muted
                        playsInline
                        disablePictureInPicture
                        disableRemotePlayback
                        controlsList="nodownload noplaybackrate"
                        onContextMenu={(e) => e.preventDefault()}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        onError={(e) => {
                            const target = e.target as HTMLVideoElement;
                            target.style.display = 'none';
                        }}
                    />
                </SwiperSlide>
            </Swiper>
            <div className="videoBgWrap"></div>
            <ul  className='deviceIconWrap'>
                <li>
                    <img src={process.env.PUBLIC_URL + "/images/Mainpage/WindowIcon.png"} alt="" />
                </li>
                <li>
                    <img src={process.env.PUBLIC_URL + "/images/Mainpage/MacIcon.png"} alt="" />
                </li>
            </ul>
        </div>
    )
}

export default GameMainEventBnrUi;